import { render, staticRenderFns } from "./pubmulti.vue?vue&type=template&id=2586bee9&scoped=true&"
import script from "./pubmulti.vue?vue&type=script&lang=js&"
export * from "./pubmulti.vue?vue&type=script&lang=js&"
import style0 from "./pubmulti.vue?vue&type=style&index=0&id=2586bee9&scoped=true&lang=less&"
import style1 from "./pubmulti.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2586bee9",
  null
  
)

export default component.exports